import { render, staticRenderFns } from "./DemoBorder.vue?vue&type=template&id=4bf535c5&scoped=true"
import script from "./DemoBorder.vue?vue&type=script&lang=js"
export * from "./DemoBorder.vue?vue&type=script&lang=js"
import style0 from "./DemoBorder.vue?vue&type=style&index=0&id=4bf535c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf535c5",
  null
  
)

export default component.exports